/*
 * Copyright (c) 2019. Sonrai Analytics Ltd.
 * Developed by Warren Dowey
 */

export class SessionHistoryModel {

  sessionHistoryId: string;
  sessionId: string;
  userId: string;
  createdAt: Date;
  updatedAt: Date;

  constructor(sessionHistoryId?: string, sessionId?: string, userId?: string, createdAt?: Date, updatedAt?: Date) {
    this.sessionHistoryId = sessionHistoryId;
    this.sessionId = sessionId;
    this.userId = userId;
    this.createdAt = createdAt;
    this.updatedAt = updatedAt;
  }

  toJson(): Object {
    const object = {
      session_history_id: this.sessionHistoryId,
      session_id: this.sessionId,
      user_id: this.userId,
      created_at: this.createdAt,
      updated_at: this.updatedAt,
    };
    Object.keys(object).forEach(k => !object[k] && typeof object[k] != "boolean" && object[k] !== undefined && delete object[k]);
    return object;
  }

  fromJson(input: any): SessionHistoryModel {
    return new SessionHistoryModel(
      input['session_history_id'],
      input['session_id'],
      input['user_id'],
      input['created_at'],
      input['updated_at']);
  }
}
